import { useState } from "react";
import { AgreementConsent } from "@/components/auth/AgreementConsent";
import { ConfirmDialog } from "@/components/common/ConfirmDialog";
import { agreementTitle } from "@/lib/agreements";
import { acceptAgreements, agreementDocumentUrl } from "@/lib/api";
import type { PendingAgreement } from "@/stores/useAgreementAcceptanceStore";

interface DeviceAgreementDialogProps {
	agreement: PendingAgreement;
	onAccepted: () => void;
	onClose: () => void;
}

/** 「デバイスを追加」の手順の前に、ローカル環境版のキャンセルポリシーへの同意を求める。 */
export function DeviceAgreementDialog({
	agreement,
	onAccepted,
	onClose,
}: DeviceAgreementDialogProps) {
	const [checked, setChecked] = useState(false);
	const title = agreementTitle(agreement.id);

	return (
		<ConfirmDialog
			open
			title={`${title}への同意`}
			message={`デバイスを追加するには、ローカル環境版の${title}を確認して同意してください。`}
			confirmLabel="同意して進む"
			confirmVariant="primary"
			confirmDisabled={!checked}
			width={640}
			onConfirm={async () => {
				await acceptAgreements([agreement]);
				onAccepted();
			}}
			onCancel={onClose}
		>
			<div style={{ marginTop: 12 }}>
				<AgreementConsent
					documentUrl={agreementDocumentUrl(agreement.id)}
					label={`${title}に同意します`}
					checked={checked}
					onCheckedChange={setChecked}
				/>
			</div>
		</ConfirmDialog>
	);
}
